import React from "react";
import { Helmet } from "react-helmet-async";
import { Alert, Container, Stack } from "@mui/material";
import ErrorAlert from "../components/alerts/ErrorAlert";
import Loading from "../components/spinners/Loading";
import TrainerAdminSummaryView from "../components/trainer/TrainerAdminSummaryView";
import TrainerPageHeader from "../components/trainer/TrainerPageHeader";
import TrainerPlanLegend from "../components/trainer/TrainerPlanLegend";
import TrainerPlanView from "../components/trainer/TrainerPlanView";
import TrainerSlotDialog from "../components/trainer/TrainerSlotDialog";
import TrainerSummaryView from "../components/trainer/TrainerSummaryView";
import useTrainerPageController from "./trainer/hooks/useTrainerPageController";

export default function TrainerPage() {
  const controller = useTrainerPageController();
  const {
    adminSummary,
    canViewAdminSummary,
    dialog,
    isError,
    isLoading,
    isMobile,
    page,
    plan,
    summary,
    trainerSites,
  } = controller;

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Container maxWidth="lg">
        <ErrorAlert errorMessage="Fehler beim Laden der Trainer-Daten." />
      </Container>
    );
  }

  if (!trainerSites.length) {
    return (
      <Container maxWidth="lg">
        <Alert severity="info" sx={{ mt: 4 }}>
          Dir wurden noch keine Standorte zugewiesen. Bitte wende dich an deinen
          Administrator.
        </Alert>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>MA | Trainer</title>
      </Helmet>

      <Container maxWidth="100%" sx={{ pb: 6 }}>
        <Stack spacing={2}>
          <TrainerPageHeader
            pageView={page.view}
            onChangeView={page.onChangeView}
            canViewAdminSummary={canViewAdminSummary}
          />

          {page.view === "plan" && <TrainerPlanLegend />}

          {page.view === "admin-summary" && canViewAdminSummary ? (
            <TrainerAdminSummaryView
              summary={adminSummary.data}
              error={adminSummary.error}
              deletingEntryKey={adminSummary.deletingEntryKey}
              isTrainerListLoading={adminSummary.isTrainerListLoading}
              trainerOptions={adminSummary.trainerOptions}
              selectedTrainerId={adminSummary.selectedTrainerId}
              onSelectTrainer={adminSummary.onSelectTrainer}
              onNavigate={adminSummary.onNavigate}
              onToday={adminSummary.onToday}
              onDeleteEntry={adminSummary.onDeleteEntry}
              onShowPlan={adminSummary.onShowPlan}
            />
          ) : page.view === "summary" ? (
            <TrainerSummaryView
              summary={summary.data}
              error={summary.error}
              deletingEntryKey={summary.deletingEntryKey}
              onNavigate={summary.onNavigate}
              onToday={summary.onToday}
              onDeleteEntry={summary.onDeleteEntry}
              onShowPlan={summary.onShowPlan}
            />
          ) : (
            <TrainerPlanView isMobile={isMobile} plan={plan} />
          )}
        </Stack>
      </Container>

      <TrainerSlotDialog dialog={dialog} />
    </>
  );
}
